{
  "fr-FR": {
    "menu": "menu",
    "mode": "mode",
    "parameters": "paramètres",
    "sound": "son",
    "subtitle": "sous-titre",
    "tutorial": "tutoriel",
    "history": "historique",
    "lang": "langues",
    "singleLang": "langue",
    "message": "Saisissez votre message",
    "allowMicrophone": "Autorisez votre navigateur à utiliser votre micro pour continuer",
    "back": "retour",
    "backconversation": "retour à la conversation",
    "close": "fermer",
    "answer": " répond à vos questions"
  },
  "en-US": {
    "menu": "menu",
    "mode": "mode",
    "parameters": "parameters",
    "sound": "sound",
    "subtitle": "subtitle",
    "tutorial": "tutorial",
    "history": "history",
    "lang": "languages",
    "singleLang": "language",
    "message": "Enter your message",
    "allowMicrophone": "Give your browser permission to use microphone to continue",
    "back": "back",
    "backconversation": "back to the conversation",
    "close": "close",
    "answer": " answers your questions"
  },
  "es-ES": {
    "menu": "menu",
    "mode": "mode",
    "parameters": "parameters",
    "sound": "sound",
    "subtitle": "subtitle",
    "tutorial": "tutorial",
    "history": "history",
    "lang": "languages",
    "singleLang": "language",
    "message": "Enter your message",
    "allowMicrophone": "Give your browser permission to use microphone to continue",
    "back": "back",
    "backconversation": "back to the conversation",
    "close": "close",
    "answer": " answers your questions"
  },
  "de-DE": {
    "menu": "menu",
    "mode": "mode",
    "parameters": "parameters",
    "sound": "sound",
    "subtitle": "subtitle",
    "tutorial": "tutorial",
    "history": "history",
    "lang": "languages",
    "singleLang": "language",
    "message": "Enter your message",
    "allowMicrophone": "Give your browser permission to use microphone to continue",
    "back": "back",
    "backconversation": "back to the conversation",
    "close": "close",
    "answer": " answers your questions"
  }
}
